/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Ai_Mcp_LabelInputs */

const en_common_header_ai_mcp_label = /** @type {(inputs: Common_Header_Ai_Mcp_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP`)
};

const zh_common_header_ai_mcp_label = /** @type {(inputs: Common_Header_Ai_Mcp_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP`)
};

/**
* | output |
* | --- |
* | "MCP" |
*
* @param {Common_Header_Ai_Mcp_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_ai_mcp_label = /** @type {((inputs?: Common_Header_Ai_Mcp_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Ai_Mcp_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_ai_mcp_label(inputs)
	return zh_common_header_ai_mcp_label(inputs)
});
export { common_header_ai_mcp_label as "common.header.ai.mcp.label" }